export const IMPORT_TABS = {
  employees: "employees",
  loginUsers: "login_users",
  extensions: "extensions",
};

export const DEFAULT_IMPORT_TAB = IMPORT_TABS.employees;

export const normalizeSearch = (search = "") => {
  if (!search) return "";
  return search.startsWith("?") ? search : `?${search}`;
};

export const buildImportOverviewPath = (search = "") => `/system-settings/import${normalizeSearch(search)}`;

export const buildEmployeeImportDetailPath = (id, search = "") => `/system-settings/import/employees/${id}${normalizeSearch(search)}`;

export const buildEmployeeImportConflictPath = id => buildEmployeeImportDetailPath(
  id,
  `tab=${IMPORT_TABS.employees}&view=conflicts`
);

export const getEmployeeImportRecordView = (search = "") => {
  const params = new URLSearchParams(normalizeSearch(search));
  return params.get("view") === "conflicts" ? "unresolved" : "all";
};

export const withoutEmployeeImportDetailState = (search = "") => {
  const params = new URLSearchParams(normalizeSearch(search));
  params.delete("view");
  return params.toString();
};

export const buildLoginUserImportDetailPath = (id, search = "") => `/system-settings/import/login-users/${id}${normalizeSearch(search)}`;
